import { CalendarService, StructuredDate } from '@optimus-web/core';

export const disableDate = (date: StructuredDate, calendarService: CalendarService) => {
    const weekdayIndex = calendarService.getWeekdayIndex(date);
    const today = calendarService.getCurrentDate();
    const minAllowedDate = calendarService.addBusinessDays(today, 5);

    const isTooSoon = calendarService.isDateLess(date, minAllowedDate);
    const isFridayToSunday = weekdayIndex === 0 || weekdayIndex >= 5;

    return isTooSoon || isFridayToSunday;
};
